import { render } from "./CollaborativeAssociation.vue?vue&type=template&id=0ecd2f8a&scoped=true"
import script from "./CollaborativeAssociation.vue?vue&type=script&lang=js"
export * from "./CollaborativeAssociation.vue?vue&type=script&lang=js"

import "./CollaborativeAssociation.vue?vue&type=style&index=0&id=0ecd2f8a&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecd2f8a"]])

export default __exports__